import { FunctionComponent, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { Box, Button, Paper, Typography, useMediaQuery } from '@mui/material'
import theme from 'src/theme'
import useSession from 'src/authentication/hooks/use-session'

let BoundTreeLogin: FunctionComponent = () => {
  let isTablet = useMediaQuery(theme.breakpoints.down('md'))
  let isPhone = useMediaQuery(theme.breakpoints.down('sm'))
  let { loginWithRedirect } = useAuth0()

  let navigate = useNavigate()
  let session = useSession()

  useEffect(() => {
    if (session) {
      navigate('/self-paced')
    }
  }, [session])

  return (
    <>
      <div
        style={{
          background:
            'linear-gradient(to left, rgba(66, 165, 245,0.4), rgba(66, 165, 245,0)) 55%, url(/banner.png)',
          backgroundSize: '25% 100%, cover',
          backgroundPosition: 'right center, center center',
          backgroundRepeat: 'no-repeat, no-repeat',
          position: 'relative',
          height: '100vh',
          marginTop: -60,
        }}
      >
        <div className="flex justify-center mt-5" style={{ paddingTop: 60 }}>
          <Typography sx={{ fontFamily: 'smileAndWave' }} variant="h4">
            Let's get started!
          </Typography>
        </div>
        <div className="mx-5">
          <Box
            sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                background: 'url(/btlogo.png)',
                flex: '0 0 312px',
                position: 'relative',
                backgroundPosition: '0px 48%',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
              }}
            ></div>

            <Paper
              // redo this in sx prop
              className={`m-4 p-4 ${
                isTablet ? `${isPhone ? 'w-full' : 'w-3/4'} mx-auto` : 'w-1/2'
              }`}
            >
              <Box sx={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => loginWithRedirect()}
                >
                  Log In
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  href="/boundtree-trial"
                  sx={{ '&:hover': { color: theme.palette.primary.main } }}
                >
                  Start a Free Trial
                </Button>
              </Box>
            </Paper>
          </Box>
        </div>
      </div>
    </>
  )
}

export default BoundTreeLogin
